"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
var _react = _interopRequireDefault(require("react"));
var _reactList = _interopRequireDefault(require("@pcty/react-list"));
var _inputTextfield = require("@citrus/input-textfield");
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Common");
var _isNotNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNotNullOrEmpty"));
var _questionBuilder = require("@pcty/question-builder");
var _PctyQuestionBuilderEdit = _interopRequireDefault(require("./PctyQuestionBuilder.Edit.QuestionOptions"));
var _span, _label;
var Presentational = function Presentational(_ref) {
  var id = _ref.id,
    builderType = _ref.builderType,
    scenario = _ref.scenario,
    question = _ref.question,
    options = _ref.options,
    knockout = _ref.knockout,
    knockoutText = _ref.knockoutText,
    hint = _ref.hint,
    number = _ref.number,
    required = _ref.required,
    editable = _ref.editable,
    onQuestionUpdated = _ref.onQuestionUpdated,
    minimumValue = _ref.minimumValue,
    maximumValue = _ref.maximumValue,
    targetSumValue = _ref.targetSumValue,
    enforceTargetSum = _ref.enforceTargetSum;
  var questionTypeId = _questionBuilder.QUESTION_TYPE.constantSum;
  var onQuestionTextUpdated = function onQuestionTextUpdated(questionText) {
    if (onQuestionUpdated) onQuestionUpdated({
      questionText: questionText
    });
  };
  var onOptionsUpdated = function onOptionsUpdated(edit) {
    var options = edit ? edit.options : [];
    if (onQuestionUpdated) onQuestionUpdated({
      options: options
    });
  };

  // setup our dummy edit container for the options' inline-editing
  var edit = {
    options: options,
    typeId: questionTypeId
  };
  var validationState = (0, _PctyQuestionBuilder.validate)(edit, true, builderType);
  var renderMinMaxLabel = function renderMinMaxLabel() {
    if (minimumValue && maximumValue) {
      return /*#__PURE__*/_react.default.createElement("label", {
        className: "pcty-input-label"
      }, "Values must be between ".concat(minimumValue, " and ").concat(maximumValue, "."));
    } else if (minimumValue && !maximumValue) {
      return /*#__PURE__*/_react.default.createElement("label", {
        className: "pcty-input-label"
      }, "Values must have a minimum of ".concat(minimumValue, "."));
    } else if (!minimumValue && maximumValue) {
      return /*#__PURE__*/_react.default.createElement("label", {
        className: "pcty-input-label"
      }, "Values must have a maximum of ".concat(maximumValue, "."));
    } else {
      return null;
    }
  };
  var renderSumLabel = function renderSumLabel() {
    if (enforceTargetSum) {
      return /*#__PURE__*/_react.default.createElement("label", {
        className: "pcty-input-label"
      }, "".concat(targetSumValue, "/").concat(targetSumValue), _span || (_span = /*#__PURE__*/_react.default.createElement("span", {
        className: "pcty-type-normal"
      }, " allocated")));
    } else {
      return _label || (_label = /*#__PURE__*/_react.default.createElement("label", {
        className: "pcty-input-label"
      }, 'Total: 0'));
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _PctyQuestionBuilder.renderHint)(id, hint), (0, _PctyQuestionBuilder.renderScenario)(id, scenario), (0, _PctyQuestionBuilder.renderQuestion)(id, questionTypeId, number, question, required, editable, onQuestionTextUpdated), (0, _PctyQuestionBuilder.renderKnockout)(id, knockout, knockoutText), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, /*#__PURE__*/_react.default.createElement(_reactList.default, {
    className: "pcty-question-builder-single-question-list",
    automationId: "".concat(id, "-mt-list")
  }, editable ? /*#__PURE__*/_react.default.createElement(_reactList.default.Item, {
    automationId: "".concat(id, "-cs-item-edit-options"),
    key: "".concat(id, "-cs-item-edit-options")
  }, /*#__PURE__*/_react.default.createElement(_reactList.default.Column, null, /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderEdit.default, {
    id: id,
    builderType: builderType,
    edit: edit,
    validationState: validationState,
    onOptionsChange: onOptionsUpdated
  }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, getListItems(id, options, minimumValue, maximumValue, targetSumValue, enforceTargetSum)), !editable && /*#__PURE__*/_react.default.createElement(_reactList.default.Item, {
    className: "totals-row",
    automationId: "".concat(id, "-cs-item-targetsum"),
    key: "".concat(id, "-cs-item-targetsum")
  }, /*#__PURE__*/_react.default.createElement(_reactList.default.Column, null, enforceTargetSum && /*#__PURE__*/_react.default.createElement("label", {
    className: "pcty-input-label"
  }, "The sum of all values must equal ".concat(targetSumValue, ".")), renderMinMaxLabel()), /*#__PURE__*/_react.default.createElement(_reactList.default.Column, {
    style: {
      width: '140px'
    }
  }, renderSumLabel()))))));
};
var getListItems = function getListItems(id, options, minimumValue, maximumValue, targetSumValue, enforceTargetSum) {
  var retOptions = options.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_reactList.default.Item, {
      automationId: "".concat(id, "-cs-item-").concat(index),
      key: "".concat(id, "-cs-item-").concat(index)
    }, /*#__PURE__*/_react.default.createElement(_reactList.default.Column, null, item.value), /*#__PURE__*/_react.default.createElement(_reactList.default.Column, {
      style: {
        width: '90px'
      }
    }, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
      formatter: function formatter(x) {
        if ((0, _isNotNullOrEmpty.default)(x) && parseInt(Math.floor(x)) > 0) {
          if (minimumValue && parseInt(minimumValue) > parseInt(Math.floor(x))) {
            return '';
          }
          if (maximumValue && parseInt(maximumValue) < parseInt(Math.floor(x))) {
            return '';
          }
          return x.toString();
        }
        return '';
      },
      id: "qb-".concat(item.id, "-cs-textfield-").concat(id.toString()),
      maxLength: 5,
      onChange: function onChange(ixd, value) {
        return console.log("".concat(ixd, " text value => ").concat(value));
      },
      placeholder: "Enter value",
      title: "All answers must be between ".concat(minimumValue, " and ").concat(maximumValue, "!")
    })));
  });
  return retOptions;
};
var _default = exports.default = Presentational;